<template>
    <form-row title="Lawn" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_lawn"
                v-model="has_lawn"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_lawn" class="pt-6 pb-2">
                <div class="flex">
                    <input-money
                        class="mr-6"
                        label="Cost"
                        placeholder="Cost"
                        name="lawn_cost"
                        v-model="lawn_cost"
                        :read_only="read_only"
                    />

                    <input-text
                        class="mr-6"
                        label="Building sq.ft."
                        v-model="square_feet"
                        :read_only="true"
                    />

                    <input-money
                        label="Cost/sq.ft."
                        :value="cost_per_square_foot"
                        :read_only="true"
                    />
                </div>

                <input-text
                    class="w-full pt-3"
                    label="Contract company"
                    placeholder="Company name"
                    name="lawn_company"
                    :value="commercial.lawn_company"
                    :read_only="read_only"
                />

                <input-textarea
                    class="w-full pt-3"
                    placeholder="Contact information"
                    name="lawn_company_contact_info"
                    :value="commercial.lawn_company_contact_info"
                    :rows="3"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_lawn: this.commercial.has_lawn,
            lawn_cost: this.commercial.lawn_cost,
        }
    },

    computed: {
        square_feet: {
            get() {
                return store.state.square_feet || null;
            },
            set(val) {
                store.state.square_feet = val;
            },
        },
        cost_per_square_foot() {
            return this.lawn_cost && this.square_feet
                ? Math.round(this.formatMoney(this.lawn_cost) / parseInt(this.square_feet) * 100) / 100
                : null;
        },
    },
}
</script>
